import { createContext, useContext } from "react";
import { type FeatureConfig, defaultFeatureConfig } from "./FeatureConfig";

export const FeatureContext =
  createContext<FeatureConfig>(defaultFeatureConfig);

export function useFeatureConfig() {
  return useContext(FeatureContext);
}
